import { Component, NgZone, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { UserActions } from "../../store/actions/user.actions";
import { Router } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { NgForm } from "@angular/forms";
import { User } from "../../models/user";
import { Angulartics2GoogleAnalytics } from "angulartics2";
import { UserService } from "../../services/user.service";
import { ProgramArticleService } from "../../services/program-article.service";
import { ChannelService } from "../../services/channel.service";
import { SidenavService } from "../../services/sidenav.service";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { ActionService } from "../../services/action.service";
import { PictureSetService } from "../../services/pictureSet.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  sessionToken: string;
  loading: boolean;
  errorMessage: string;
  autofocus: boolean;
  arkoseDisabled: boolean;

  @ViewChild("loginForm") loginForm: NgForm;
  @ViewChild("loginInput") loginInput: any;

  /**
   * Set the title of the page
   * @param {AuthService} authService
   * @param {UserActions} userActions
   * @param {Router} router
   * @param {Angulartics2GoogleAnalytics} angulartics2GoogleAnalytics
   * @param {Title} title
   */
  constructor(
    private authService: AuthService,
    private programArticleService: ProgramArticleService,
    private channelService: ChannelService,
    private actionService: ActionService,
    private pictureSetService: PictureSetService,
    private userActions: UserActions,
    private router: Router,
    private userService: UserService,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private title: Title,
    private ngZone: NgZone,
    private sidenavService: SidenavService,
  ) {
    this.title.setTitle("Taiga - Login");
    this.sidenavService.currentTab = "";
    this.arkoseDisabled = true;
  }

  /**
   * Set focus on login input
   */
  ngOnInit() {
    setTimeout(() => {
      this.loginInput.nativeElement.focus();
    }, 200);

    this.actionService
      .getFeatureLanguageStatus("ARKOSE_DISABLED", 0)
      .subscribe((result: boolean) => {
        this.arkoseDisabled = result;
        if (!this.arkoseDisabled) {
          // for arkose, need to add login form submit method into javascript
          window["angularComponentReference"] = {
            component: this,
            zone: this.ngZone,
            submitLoginForm: (sessionToken) =>
              this.submitLoginForm(sessionToken),
          };
        }
      });
  }

  generateRandomName(base: string): string {
    return `${base}_${Math.random().toString(36).substring(2)}`;
  }

  /**
   * When the form is submit and valid the login is processed
   */
  submitLoginForm(sessionToken: string) {
    this.sessionToken = sessionToken;
    if (this.loginForm.valid) {
      this.loginProcess();
    }
  }

  /**
   * Check login with an API call and add user to the store and add data for google analytics
   */
  loginProcess() {
    this.loading = true;
    this.authService
      .login(this.username, this.password, this.sessionToken)
      .subscribe(
        (user: User) => {
          if (user.id > 0) {
            localStorage.clear();
            this.userActions.loginUser(user);
            this.userActions.changeLanguage(user.currentLanguage);

            //Save user token generated from back end
            localStorage.setItem("BearerToken", JSON.stringify(user.jwtToken));

            //Get Picture Set
            this.pictureSetService
              .getAllPictureSets()
              .subscribe((pictureSet) => {
                localStorage.setItem(
                  "pictureSet",
                  JSON.stringify(pictureSet.values)
                );
              });

            // Update countries and broadcasting countries
            this.programArticleService
              .getBroadcastingCountries(
                parseInt(localStorage.getItem("current_language_id"))
              )
              .subscribe((countries) => {
                localStorage.setItem("countries", JSON.stringify(countries));

                // Update user Channels
                this.channelService
                  .getUserChannels(user.currentLanguage)
                  .subscribe((channels) => {
                    localStorage.setItem("channels", JSON.stringify(channels));

                    // Get Users destinations
                    this.programArticleService
                      .getDestinations(true)
                      .subscribe((destinations) => {
                        localStorage.setItem(
                          "destinations",
                          JSON.stringify(destinations)
                        );

                        this.userService.keepSessionAlive();
                        this.angulartics2GoogleAnalytics.setUsername(
                          user.login
                        );
                        this.router.navigateByUrl(this.authService.redirectUrl);
                        this.loading = false;
                      });
                  });
              });
          }
        },
        (err) => {
          this.loading = false;
          this.errorMessage = err;
          setTimeout(() => (this.errorMessage = null), 5000);
        }
      );
  }

  exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getDate() + ".xlsx"
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts